import { ButtonProps } from '@mui/material/Button'

import { FCWithChildren } from '@/types'

import Button from '@/Components/Common/Button/Button'

type CardButtonProps = ButtonProps

const CardButton: FCWithChildren<CardButtonProps> = ({
  loading,
  type = 'submit',
  children,
  ...props
}) => {
  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      type={type}
      loading={loading}
      {...props}
    >
      {children}
    </Button>
  )
}

export default CardButton
